import { writable } from "svelte/store";
export const search = writable({ andor: "and", terms: "" });
